export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export function getJsonRequest<TBody>(method: HttpMethod, body?: TBody): RequestInit {
    return {
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    };
}

export function getStatusOnlyRequest(method: HttpMethod): RequestInit {
    return { method: method };
}

export function isUnAuthorizedHttpsStatus(httpStatus: number) {
    return httpStatus === 403;
}

export function isNotFoundHttpStatus(httpStatus: number) {
    return httpStatus === 404;
}